/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

import {hasUserRole, UserRole} from './../../../utils/commonFunctions';

const activityLogApi = async (params?: any): Promise<any> => {
  const {userToken, userDetails} = useUserStore.getState();
  const {companyId} = useCompanyStore.getState();
  const facilityId = hasUserRole(UserRole.Facility_Admin)
    ? userDetails.facility
    : null;

  try {
    const response = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.activityLog}/${companyId}/${
        facilityId ?? 'null'
      }`,
      headers: {
        Authorization: `Bearer ${userToken}`
      },
      params
    });

    return response.data.data;
  } catch (err) {
    return {
      data: [],
      total: 0
    };
  }
};

export default activityLogApi;
